// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-datetime-field.v-input[data-v-73c37616]>.v-input__control>.v-input__slot{display:block!important}.v-datetime-field.v-input[data-v-73c37616]>.v-input__control>.v-messages{padding:0 12px;margin-bottom:8px}.v-datetime-field__wrapper[data-v-73c37616]{display:flex;margin-top:4px;gap:8px}.v-datetime-field__date[data-v-73c37616]{flex:1}.v-datetime-field__time[data-v-73c37616] .v-text-field input{max-width:100px}", ""]);
// Exports
module.exports = exports;
